// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UmbracoRouteImport } from './routes/umbraco'
import { Route as UmbracoContentLayoutRouteImport } from './routes/_umbraco/_content/_layout'
import { Route as UmbracoPreviewUmbracoLayoutRouteImport } from './routes/_umbraco/_preview/umbraco/_layout'
import { Route as UmbracoContentSplatRouteImport } from './routes/_umbraco/_content/$'
import { Route as UmbracoPreviewUmbracoBlockPreviewRouteImport } from './routes/_umbraco/_preview/umbraco/block-preview'

const UmbracoRoute = UmbracoRouteImport.update({
            id: '/umbraco',path: '/umbraco',getParentRoute: () => rootRouteImport
          })
const UmbracoContentLayoutRoute = UmbracoContentLayoutRouteImport.update({
            id: '/_umbraco/_content',getParentRoute: () => rootRouteImport
          })
const UmbracoPreviewUmbracoLayoutRoute = UmbracoPreviewUmbracoLayoutRouteImport.update({
            id: '/_umbraco/_preview/umbraco',path: '/umbraco',getParentRoute: () => rootRouteImport
          })
const UmbracoContentSplatRoute = UmbracoContentSplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => UmbracoContentLayoutRoute
          })
const UmbracoPreviewUmbracoBlockPreviewRoute = UmbracoPreviewUmbracoBlockPreviewRouteImport.update({
            id: '/block-preview',path: '/block-preview',getParentRoute: () => UmbracoPreviewUmbracoLayoutRoute
          })





const UmbracoContentLayoutRouteChildren = {
  UmbracoContentSplatRoute: UmbracoContentSplatRoute
}

const UmbracoContentLayoutRouteWithChildren = UmbracoContentLayoutRoute._addFileChildren(UmbracoContentLayoutRouteChildren)




const UmbracoPreviewUmbracoLayoutRouteChildren = {
  UmbracoPreviewUmbracoBlockPreviewRoute: UmbracoPreviewUmbracoBlockPreviewRoute
}

const UmbracoPreviewUmbracoLayoutRouteWithChildren = UmbracoPreviewUmbracoLayoutRoute._addFileChildren(UmbracoPreviewUmbracoLayoutRouteChildren)

const rootRouteChildren = {
  UmbracoRoute: UmbracoRoute,UmbracoContentLayoutRoute: UmbracoContentLayoutRouteWithChildren,UmbracoPreviewUmbracoLayoutRoute: UmbracoPreviewUmbracoLayoutRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)